/**
 * Account Template.
 */
import Animator from '@components/elements/animator/animator';
import Body from '@components/sections/account/accountBody';
import Container from '@components/atoms/container/accountContainer';
import QR from '@components/sections/account/accountQR';
import useAccountTemplate from '../lib/useAccountTemplate';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Handles the account information display and CMP integration.
 */
export default function AccountTemplate() {
  // Hooks
  const { callbacks, props } = useAccountTemplate();
  const menuExpanded = !useAppSelector(selectMenuCollapse);

  // Render
  return (
    <Animator
      id={'accountContainer'}
      type={Animator.Type.SETTING}
      collapse={{ horizontal: menuExpanded }}
    >
      <Container {...props} {...callbacks}>
        <Body />
        <QR />
      </Container>
    </Animator>
  );
}
